import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"
import { Chart, registerables } from 'chart.js';
import VueChart3 from 'vue-chart-3';
import './assets/styles/tailwind.css'
import permissionsPlugin from './plugins/permissions'
import './registerServiceWorker'
import { installMaintenanceGuard } from '@/plugins/maintenanceGuard';
import { SecurityModeService } from '@/views/panelMantenimiento/Services/SecurityModeService';

Chart.register(...registerables);

const app = createApp(App);

app.use(store);
app.use(router);

const roleToken = store.state.roleToken;

app.use(Toast, {
  position: 'top-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false,
  maxToasts: 10
});

// 👇 para usar toast en plugins/guards fuera de componentes
window.$toast = app.config.globalProperties.$toast;

app.use(VueChart3);
app.use(permissionsPlugin, { roleToken });

// 👇 guard global mantenimiento
installMaintenanceGuard(router);

const cached = SecurityModeService.getCached();
if (cached) store.commit('setSecurityMode', cached.enabled);

app.mount('#app');